<app-bread-crump [title]="translate.currentLang === 'en' ? 'Quranic Sciences in Musahifs' : 'علوم القرآن في المصاحف'" [description]="''"
  [items]="[
    { label:('Nav.Home' | translate), url: '/home' },
    { label: translate.currentLang === 'en' ? 'Quranic Sciences in Musahifs' : 'علوم القرآن في المصاحف' }
  ]">
</app-bread-crump>

<section class="container d-flex flex-column my-5" style="max-width: 1280px">

  @if (loading()) {
  <div class="text-center my-5">
    <span>{{ 'COMMON.loading' | translate }}</span>
  </div>
  } @else {
  <div class="global-cards-row" style="margin-block: 40px;">

    @for (item of newsArticles; track item.id) {
    <div class="global-cards-row__container">
      <div class="global-card">
          <img loading="lazy" class="community_img" [src]="getFileUrl(item.imageUrl)"
              [alt]="translate.currentLang === 'en' ? item.titleEN : item.titleAR" onerror="this.src='/media/images/custom/defualt-img.jpg'">
          <!-- <div class="texts">
              <h3>{{ translate.currentLang === 'en' ? item.titleEN : item.titleAR }}</h3>
          </div> -->
          <div class="buttons justify-content-start">
              <a [routerLink]="['/news-details', item.id]" class="btn-primary without-min" translate="READ_MORE"></a>
          </div>
      </div>
    </div>
    }
  </div>

  @if (newsArticles.length === 0) {
  <div class="text-center my-5">
    <p>لا يوجد بيانات لعرضها.</p>
  </div>
  }

  @if (pagination.totalPages > 1) {
  <div class="mt-4">
    <app-browse-paginator [pagination]="pagination" (pageChange)="onPageChange($event)">
    </app-browse-paginator>
  </div>
  }
  }
</section>

<!-- Starts : Footer -->
<app-footer></app-footer>
<!-- Ends : Footer -->
